<template>
  <aside class="settings-panel">
    <div class="settings-panel__close">
      <close-button @click="handleClose"/>
    </div>
    <div class="settings-panel__cell settings-panel__cell--add-place settings-panel__cell--switcher">
      <router-link
        tag="button"
        class="settings-panel__btn"
        :to="{ name: 'add-step-1' }"
      >+ Dodaj miejsce</router-link>
    </div>
    <div class="settings-panel__cell settings-panel__cell--switcher">
      <button
        class="settings-panel__btn"
        :class="{ 'settings-panel__btn--is-active': isActive('tile') }"
        @click="handleSwitch"
      >Układ kaflowy</button>
      <button
        class="settings-panel__btn"
        :class="{ 'settings-panel__btn--is-active': isActive('map') }"
        @click="handleSwitch"
      >Widok Mapy</button>
    </div>
    <div class="settings-panel__cell settings-panel__cell--filters">
      <button
        class="settings-panel__btn"
        @click="handleFiltersClick"
      >Filtrowanie</button>
    </div>
  </aside>
</template>

<script>
import CloseButton from '@/components/CloseButton'

export default {
  components: {
    CloseButton
  },
  props: {
    type: {
      type: String,
      default: '',
      validator: propValue => ['tile', 'map'].includes(propValue)
    }
  },
  computed: {
    isActive () {
      return type => this.type === type
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleSwitch () {
      this.$emit('switch')
    },
    handleFiltersClick () {
      this.$emit('filters')
    }
  }
}
</script>

<style lang="scss" scoped>
  .settings-panel {
    @include hide-up(md);
    position: fixed;
    bottom: 0;
    left: 0;

    width: 100%;

    background-color: $base-text-color;
    z-index: z(details) + 1;
    box-shadow: 0px 12px 43.24px 2.76px rgba(0, 0, 0, 0.65);

    &__close {
      position: absolute;
      top: 10px;
      right: 20px;
    }

    &__cell {
      height: 92px;
      display: flex;
      justify-content: center;
      align-items: center;

      &--add-place {
        margin-top: 10px;
      }

      &--switcher {
        border-bottom: 1px solid #ccc;
      }
    }

    &__btn {
      @include reset-button;
      @include uppercase-text;
      text-align: center;
      padding: 4px;
      margin: 0 10px;
      border-bottom: 3px solid transparent;

      &--is-active {
        color: $accent-color;
        border-bottom-color: $accent-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Settings/SettingsPanel.vue